export default "<div class=\"site-bullet\">\n  <span [ngStyle]=\"{'border-color': color, 'background': color + '20'}\"></span>\n  {{this.title}}\n</div>\n"